import { calculateDistance } from 'helpers/drag';
import { isTargetElement } from 'helpers/gestures';
import { LEFT } from 'constants/mouse';
import { Position, GestureNativeEvent } from 'types';

const LONGPRESS_TIME = 1000;
const WIGGLE_THRESHOLD = 2;

let target: HTMLElement | null = null;
let timer: number | null = null;
let initPosition: Position | null = null;
let position: Position | null = null;
let eventType: string | null = null;
let move: (e: GestureNativeEvent) => void;

const reset = () => {
  document.removeEventListener(`${ eventType }move`, move as any, false);

  clearTimeout(timer!);
  timer = null;
  target = null;
  eventType = null;
};

const onSuccess = () => {
  if (!target) {
    reset();
    return;
  }

  const event = document.createEvent('Event');
  event.initEvent('longpress', true, true);
  target.dispatchEvent(event);

  reset();
};

const check = () => {
  if (!position || !initPosition) return 0;

  const distance = calculateDistance(position, initPosition);
  return distance <= WIGGLE_THRESHOLD;
};

const down = (e: GestureNativeEvent) => {
  if (e.simulated) return;
  if (eventType !== null && !e.type.includes(eventType)) return;
  if ((e.type === 'mousedown' || e.type === 'pointerdown') && (e as MouseEvent).button !== LEFT) return;
  if (!isTargetElement(e)) return;

  target = e.target;
  eventType = e.type.replace('down', '').replace('start', '');
  initPosition = {
    x: e.pageX,
    y: e.pageY,
  };
  position = initPosition;

  timer = window.setTimeout(() => {
    if (!check()) {
      reset();
      return;
    }

    onSuccess();
  }, LONGPRESS_TIME);

  move = (event: GestureNativeEvent) => {
    if (!timer) return;
    position = {
      x: event.pageX,
      y: event.pageY,
    };
  };

  document.addEventListener(`${ eventType }move`, move as any, false);
};

const up = (e: GestureNativeEvent) => {
  if (eventType !== null && !e.type.includes(eventType)) return;

  reset();
};

export {
  down,
  up,
};
